import { AnnounceMode } from '../components/ClinAnnounceBar/ClinAnnounceBar'
import {
  AnnouncePresentation,
  IAnnouncementAction
} from '../types/IAnnouncement'

export enum AnnounceEventType {
  SHOW = 'ShowAnnounceEvent',
  HIDE = 'HideAnnounceEvent',
  UPDATE_FLAG = 'UpdateAnnounceEvent'
}

// Show ------------------------------------------------------------------------

export interface IShowAnnounceEvent {
  /** Event type is fixed */
  type: AnnounceEventType.SHOW
  /** Title announce bar mode */
  mode: AnnounceMode
  /** Description of the announce */
  description?: string
  /** Title of the announce */
  title?: string
  /** Should clear announcement on navigation */
  clearOnNavigationFlag?: boolean
  /** Full-width bar (default) or a toast at the top right of the page */
  presentation?: AnnouncePresentation
  /** Optional link shown in a toast */
  action?: IAnnouncementAction
}

export const createAnnounceEvent = (
  mode: AnnounceMode,
  description?: string,
  title?: string,
  clearOnNavigationFlag: boolean = true,
  presentation?: AnnouncePresentation
): IShowAnnounceEvent => ({
  type: AnnounceEventType.SHOW,
  mode,
  description,
  title,
  clearOnNavigationFlag,
  presentation
})

/**
 * CLOS-14590: an announcement shown as a toast at the top right of the page,
 * like the PTA consent toast, instead of the full-width bar.
 */
export const createToastAnnounceEvent = (
  mode: AnnounceMode,
  description?: string,
  title?: string,
  action?: IAnnouncementAction
): IShowAnnounceEvent => ({
  ...createAnnounceEvent(
    mode,
    description,
    title,
    true,
    AnnouncePresentation.Toast
  ),
  action
})

// Hide ------------------------------------------------------------------------

export interface IHideAnnounceEvent {
  type: AnnounceEventType.HIDE
}

export const clearAnnounceEvent = (): IHideAnnounceEvent => ({
  type: AnnounceEventType.HIDE
})

// Update ------------------------------------------------------------------------

export interface IUpdateAnnounceFlag {
  type: AnnounceEventType.UPDATE_FLAG
  clearOnNavigationFlag: boolean
}

export const updateAnnounceClearFlag = (
  clearOnNavigationFlag: boolean
): IUpdateAnnounceFlag => ({
  type: AnnounceEventType.UPDATE_FLAG,
  clearOnNavigationFlag
})

export type IAnnounceEvent =
  | IShowAnnounceEvent
  | IHideAnnounceEvent
  | IUpdateAnnounceFlag
